@if (vm$ | async; as modal) {
	<bci-wk-modal (destroyModalEmmiter)="onEventCloseModal(modal.tags?.actions?.default)">
		<div class="container flex">
			<img [src]="modal.asset" alt="modal image" class="image" />
			<bci-wk-modal-title class="text title">{{ modal.title }}</bci-wk-modal-title>

			<p class="text description">{{ modal.description }}</p>

			<bci-wk-modal-actions>
				<div class="wrap-buttons">
					<button
						(click)="
							onButtonActionHandler(modal.primaryButton.action, modal.tags?.actions?.primaryAction)
						"
						bciWkButtonPrimary
						class="primary"
					>
						{{ modal.primaryButton.text }}
					</button>
					<button
						*ngIf="modal.secondaryButton"
						(click)="
							onButtonActionHandler(modal.secondaryButton.action, modal.tags?.actions?.secondaryAction)
						"
						bciWkButtonSecondary
						class="secondary"
					>
						{{ modal.secondaryButton.text }}
					</button>
					<button
						*ngIf="modal.tertiaryButton"
						(click)="
							onButtonActionHandler(modal.tertiaryButton.action, modal.tags?.actions?.tertiaryAction)
						"
						bciWkButtonTertiary
					>
						{{ modal.tertiaryButton.text }}
					</button>
				</div>
			</bci-wk-modal-actions>
		</div>
	</bci-wk-modal>
}
